import { useState, type ComponentProps } from "react"

import { toast } from "sonner"

import { downloadFile } from "@/lib/files"
import { cn } from "@/lib/utils"

type DownloadButtonProps = Omit<ComponentProps<"button">, "onClick"> & {
  filename: string
  url: string
}

export function DownloadButton({
  children,
  className,
  disabled,
  filename,
  url,
  ...props
}: DownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState(false)

  const handleDownload = async () => {
    setIsDownloading(true)
    try {
      await downloadFile(url, filename)
    } catch {
      toast.error("Unable to download the document. Please try again.")
    } finally {
      setIsDownloading(false)
    }
  }

  return (
    <button
      type="button"
      aria-busy={isDownloading}
      className={cn("cursor-pointer disabled:cursor-default", className)}
      disabled={disabled || isDownloading}
      onClick={handleDownload}
      {...props}
    >
      {children}
    </button>
  )
}
